module.exports = __webpack_public_path__ + "img/btn_unfinished.d330e5f2.png";